// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Rose_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 4.5a8.2 8.2 0 0 0-3.315.697c-1.416-2.379-3.742-3.563-3.85-3.618a.75.75 0 0 0-.67 0c-.108.054-2.438 1.24-3.85 3.618A8.2 8.2 0 0 0 4.5 4.5a.75.75 0 0 0-.75.75V9a8.26 8.26 0 0 0 7.5 8.215v3.322l-3.414-1.708a.75.75 0 1 0-.672 1.342l4.5 2.25a.75.75 0 0 0 .672 0l4.5-2.25a.75.75 0 0 0-.672-1.342l-3.414 1.708v-3.322A8.26 8.26 0 0 0 20.25 9V5.25a.75.75 0 0 0-.75-.75Zm-8.25 11.209A6.76 6.76 0 0 1 5.25 9V6.041a6.76 6.76 0 0 1 6 6.709ZM12 9.315a8.3 8.3 0 0 0-2.873-3.39c.898-1.481 2.25-2.43 2.873-2.813.623.382 1.976 1.33 2.873 2.812A8.3 8.3 0 0 0 12 9.315ZM18.75 9a6.76 6.76 0 0 1-6 6.709V12.75a6.76 6.76 0 0 1 6-6.709Z',
  viewBox: '0 0 24 24',
  glyph: 'Rose_Stroke2_Corner0_Rounded',
})
